export default __webpack_public_path__ + "static/media/imgIco02.a92b29cc.webp";